// extracted by mini-css-extract-plugin
module.exports = {"main":"styles_main__11CWh","focus":"styles_focus__2mGWd"};